module.exports = __webpack_public_path__ + "static/media/slider-1-min.293c06d6.jpg";